import { SdcRootCtrl } from './sdc-root.controller';

export const SdcRootComponent = {
  template: require('./sdc-root.component.html'),
  bindings: {
    currentUser: '<',
    currentState: '<',
  },
  controller: SdcRootCtrl,
};
